export const datetimeMomentFormat = 'MM/DD/YYYY';

export const legacyDatabaseExpiryDate = { day: 11, month: 7, year: 2024 };
export const csmDefaultDashboardsExpiryDate = { day: 8, month: 8, year: 2024 };
export const CcusDashboardExpiryDate = { day: 6, month: 9, year: 2024 };
